import Popover, { IPopoverRef, PopoverPlacement, IProps as IPopoverProps } from './Popover';

export type { IPopoverRef, PopoverPlacement, IPopoverProps };
export default Popover;
